import angular from 'angular';
import angularRoute from 'angular-route';

import ActivateAccountCtrl from './activate/activate-ctrl';
import ActivateResendCtrl from './resend/resend-ctrl';
import ActivateConfirmationCtrl from './confirmation/confirmation-ctrl';

import routes from './activate-routes.js';

export default angular.module('activate', [angularRoute])
    .controller('ActivateAccountCtrl', ActivateAccountCtrl)
    .controller('ActivateResendCtrl', ActivateResendCtrl)
    .controller('ActivateConfirmationCtrl', ActivateConfirmationCtrl)
    .config(routes)
    .name;



// WEBPACK FOOTER //
// ./activate/activate-module.js